import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37071677"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "cesium-container",
  style: {"width":"100%","height":"100%"}
}, null, -1))
const _hoisted_2 = { class: "time-slider" }
const _hoisted_3 = { class: "right-tool" }
const _hoisted_4 = {
  class: "cesium-button",
  style: {"overflow":"inherit"}
}
const _hoisted_5 = {
  key: 0,
  class: "cesium-button"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-juliceliang" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-mianjiceliang" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "status-bar" }
const _hoisted_14 = { class: "lonlat-indicator" }
const _hoisted_15 = { class: "lonlat" }
const _hoisted_16 = { class: "lonlat" }
const _hoisted_17 = {
  key: 0,
  class: "lonlat"
}
const _hoisted_18 = { class: "bottom-scale" }
const _hoisted_19 = {
  key: 0,
  class: "status-bar"
}
const _hoisted_20 = { id: "scale-label" }

import { onMounted, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import * as Cesium from 'cesium';
import Compass from '../vendors/cesium/Compass';
import ZoomController from '@cesium-extends/zoom-control';
import Subscriber from '@cesium-extends/subscriber';
import FixedIdentifyPopup from './FixedIdentifyPopup.vue';
import MapSwitch from './MapSwitch.vue';
import TimeLine from './TimeLine.vue';
import TimeSlider from './TimeSlider/TimeSlider.vue';
import TimeFeature from './TimeSlider/TimeFeature.vue';
import CesiumEngine from '@/models/engine/CesiumEngine';
import { useStore } from 'vuex';
import { DistanceMeasure, AreaMeasure } from '@cesium-extends/measure';
import Cookies from 'js-cookie';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'CesiumViewer',
  setup(__props) {

const isDeepearth = process.env.VUE_APP_IS_DDE != 'true';

const { track } = useTrack();

const { t } = useI18n();
// DD: Decimal Degrees
// DMS: Degrees, Minutes, and Seconds
const lonLatFormat = ref(Cookies.get('lonlat_format') || 'DD');
const lonValue = ref(0);
const latValue = ref(0);
const formattedLon = computed(() => {
  if (lonLatFormat.value === 'DD') {
    return toDD(Math.abs(lonValue.value)) + ' ' + addDirection(true);
  } else {
    return toDMS(Math.abs(lonValue.value)) + ' ' + addDirection(true);
  }
});

const formattedLat = computed(() => {
  if (lonLatFormat.value === 'DD') {
    return toDD(Math.abs(latValue.value)) + addDirection(false);
  } else {
    return toDMS(Math.abs(latValue.value)) + addDirection(false);
  }
});

const cesiumViewer = ref<Cesium.Viewer>();
const infoOn = ref(false);
const distanceMeasureOn = ref(false);
const areaMeasureOn = ref(false);
const clickPosition = ref();
const store = useStore();
const distanceMeasure = ref();
const areaMeasure = ref();
const viewpoint = ref({
  height: '0 m',
  mode: Cesium.SceneMode.SCENE2D,
});
const barWidth = ref();
const distanceLabel = ref();
const magnitude = ref();

const scales = [
  1, 2, 3, 5, 10, 20, 30, 50, 100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000,
  20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000,
  3000000, 5000000,
];

const toggleInfo = () => {
  infoOn.value = !infoOn.value;
  clickPosition.value = null;
};


const startOrStopMeasure = (measure, isOn) => {
  if (measure.value) {
    if (isOn) {
      measure.value.start();
    } else {
      measure.value.end();
    }
  }
};

const toggleDistanceMeasureOn = () => {
  distanceMeasureOn.value = !distanceMeasureOn.value;
  startOrStopMeasure(distanceMeasure, distanceMeasureOn.value)
  if (areaMeasureOn.value) {
    areaMeasureOn.value = false;
    startOrStopMeasure(areaMeasure, false)
  }
};

const toggleAreaMeasureOn = () => {
  areaMeasureOn.value = !areaMeasureOn.value;
  startOrStopMeasure(areaMeasure, areaMeasureOn.value)
  if (distanceMeasureOn.value) {
    distanceMeasureOn.value = false;
    startOrStopMeasure(distanceMeasure, false)
  }
};

const switchLatLonFormat = () => {
  lonLatFormat.value = lonLatFormat.value === 'DD' ? 'DMS' : 'DD';
  Cookies.set('lonlat_format', lonLatFormat.value);
}

const toDMS = (radian) => {
  var degrees = Cesium.Math.toDegrees(radian);
  var degree = Math.floor(degrees);

  var fraction = degrees - degree;
  var minutes = fraction * 60;
  var minute = Math.floor(minutes);

  fraction = minutes - minute;
  var second = Math.floor(fraction * 60);

  return degree + '°' + minute + "'" + second + "''";
};

const toDD = (radian) => {
  return Cesium.Math.toDegrees(radian).toFixed(8);
};

const addDirection = (isLon) => {
  if (isLon) {
    return lonValue.value >= 0 ? 'E' : 'W';
  } else {
    return latValue.value >= 0 ? 'N' : 'S';
  }
};

const computeScale = (viewer) => {
  var scene = viewer.scene;
  var width = scene.canvas.clientWidth;
  var height = scene.canvas.clientHeight;

  var left = scene.camera.getPickRay(new Cesium.Cartesian2(0, height / 2));
  var right = scene.camera.getPickRay(new Cesium.Cartesian2(width, height / 2));

  var globe = scene.globe;
  var leftPosition = globe.pick(left, scene);
  var rightPosition = globe.pick(right, scene);

  if (!Cesium.defined(leftPosition) || !Cesium.defined(rightPosition)) {
    barWidth.value = undefined;
    distanceLabel.value = undefined;
    return;
  }

  var meterDistance = Cesium.Cartesian3.distance(leftPosition, rightPosition);
  var pixelDistance = Cesium.Cartesian2.distance(
    new Cesium.Cartesian2(0, height / 2),
    new Cesium.Cartesian2(width, height / 2),
  );
  let maxBarWidth = 100;
  let distance;
  for (let i = scales.length - 1; !Cesium.defined(distance) && i >= 0; --i) {
    if ((scales[i] * pixelDistance) / meterDistance < maxBarWidth) {
      distance = scales[i];
    }
  }

  if (Cesium.defined(distance)) {
    var label =
      distance >= 1000
        ? (distance / 1000).toString() + ' ' + t('NavigationBar.km')
        : distance.toString() + ' ' + t('NavigationBar.m');
    barWidth.value = ((distance * pixelDistance) / meterDistance) | 0;
    distanceLabel.value = label;
  } else {
    barWidth.value = undefined;
    distanceLabel.value = undefined;
  }
};

const bindCameraInfo = (viewer) => {
  var scene = viewer.scene;
  var ellipsoid = scene.globe.ellipsoid;

  var handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
  handler.setInputAction(function (movement) {
    var cartesian = viewer.camera.pickEllipsoid(
      movement.endPosition,
      ellipsoid,
    );
    var height = viewer.camera.positionCartographic.height;
    if (cartesian) {
      var cartographic = ellipsoid.cartesianToCartographic(cartesian);
      viewpoint.value = {
        height: height.toFixed(2) + ' m',
        mode: viewer.scene.mode,
      };
      lonValue.value = cartographic.longitude;
      latValue.value = cartographic.latitude;
    } else {
      viewpoint.value = {
        height: '0 m',
        mode: viewer.scene.mode,
      };
      lonValue.value = 0;
      latValue.value = 0;
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
};

const createDefaultBaselayer = () => {
  return new Cesium.UrlTemplateImageryProvider({
    url: process.env.VUE_APP_BASEMAP_YINGXIANG,
    subdomains: ['1', '2', '3'],
    maximumLevel: 18, // 最大级别（可选）
  });
};

const listenBBoxChange = (viewer) => {
  viewer.camera.moveEnd.addEventListener(() => {
    const bounds = viewer.camera.computeViewRectangle(viewer.scene.globe.ellipsoid);
    if (bounds) {
      const bbox = {
        west: Cesium.Math.toDegrees(bounds.west),
        south: Cesium.Math.toDegrees(bounds.south),
        east: Cesium.Math.toDegrees(bounds.east),
        north: Cesium.Math.toDegrees(bounds.north)
      };
      console.log('bbox', bbox);
      store.commit('engineStore/setBBox', bbox);      
    }
  });
}

const initAreaMeasure = (viewer) => {
  areaMeasure.value = new AreaMeasure(viewer, {
    units: 'kilometers',
    locale: {
      start: t('start'),
      area: t('area'),
      total: t('total'),
      formatLength: (length, unitedLength) => {
        if (length < 1000) {
          return length + t('meter');
        }
        return unitedLength + t('kilometer');
      },
      formatArea: (area, unitedArea) => {
        if (area < 1000000) {
          return area + t('squareMeter');
        }
        return unitedArea + t('squareKilometer');
      },
    },
    drawerOptions: {
      tips: {
        init: t('click_to_draw'),
        start: t('draw_tip'),
      },
    },
    labelStyle: {
      heightReference: Cesium.HeightReference.NONE,
    },
    onEnd: (entity) => {
      console.log(entity);

      track(FunctionIdEnum.globalLayer_earth_calculate, EventTypeEnum.CLICK, {
        type: 'area',
      });
    },
  });
}

const initDistanceMeasure = (viewer) => {
  distanceMeasure.value = new DistanceMeasure(viewer, {
    locale: {
      start: t('start'),
      area: t('area'),
      total: t('total'),
      formatLength: (length, unitedLength) => {
        if (length < 1000) {
          return length + t('meter');
        }
        return unitedLength + t('kilometer');
      },
    },
    onEnd: () => {
      track(FunctionIdEnum.globalLayer_earth_calculate, EventTypeEnum.CLICK, {
        type: 'distance',
      });
    },
    labelStyle: {
      heightReference: Cesium.HeightReference.NONE,
    },
    drawerOptions: {
      tips: {
        init: t('click_to_draw'),
        start: t('draw_tip'),
      },
    },
  });
}

onMounted(() => {
  const defaultBaselayer = createDefaultBaselayer();

  const viewer = new Cesium.Viewer('cesium-container', {
    navigationHelpButton: false,
    timeline: false,
    animation: false,
    fullscreenButton: false,
    shouldAnimate: false,
    skyBox: false,
    imageryProvider: false,
    sceneModePicker: false,
    geocoder: false,
    homeButton: false,
    baseLayerPicker: false,
    sceneMode: Cesium.SceneMode.SCENE2D,
    // mapProjection: new Cesium.WebMercatorProjection(),
    infoBox:false
  });
  const fullExtent = new Cesium.Rectangle.fromDegrees(-180, -90, 180, 90);
  viewer.camera.setView({
    destination: fullExtent
  });
  viewer.imageryLayers.addImageryProvider(defaultBaselayer);
  viewer.scene.backgroundColor = Cesium.Color.BLACK;
  viewer.cesiumWidget.creditContainer.style.display = 'none';
  viewer.cesiumWidget.scene.globe.baseColor = Cesium.Color.BLACK;
  new Compass(viewer);
  new ZoomController(viewer, {
    tips: {
      zoomIn: t('NavigationBar.zoomin'),
      zoomOut: t('NavigationBar.zoomout'),
      refresh: t('NavigationBar.resetzoom'),
    }
  });

  const subscriber = new Subscriber(viewer);
  subscriber.addExternal((movement, _) => {
    if (movement) {
      const cartesian2 = new Cesium.Cartesian2(
        movement.position?.x,
        movement.position?.y,
      );
      const cartesian3 = viewer.camera.pickEllipsoid(
        cartesian2,
        viewer.scene.globe.ellipsoid,
      );
      if (!cartesian3) return;
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian3);
      const longitude = Cesium.Math.toDegrees(cartographic.longitude);
      const latitude = Cesium.Math.toDegrees(cartographic.latitude);
      if (infoOn.value) {
        clickPosition.value = [longitude, latitude];
      }
    }
  }, 'LEFT_CLICK');

  cesiumViewer.value = viewer;
  const engine = new CesiumEngine(viewer);
  store.dispatch('engineStore/setEngine', engine);
  initDistanceMeasure(viewer);
  initAreaMeasure(viewer);
  bindCameraInfo(viewer);

  viewer.camera.changed.addEventListener(() => {
    var camera = viewer.camera;
    var position = camera.positionWC;
    var mag = Cesium.Cartesian3.magnitude(position);
    if (magnitude.value !== mag) {
      magnitude.value = mag;
      computeScale(viewer);
    }
  });

  listenBBoxChange(viewer);
});

return (_ctx: any,_cache: any) => {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TimeSlider, { viewer: cesiumViewer.value }, null, 8, ["viewer"]),
      _createVNode(TimeFeature, { viewer: cesiumViewer.value }, null, 8, ["viewer"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(MapSwitch, { viewer: cesiumViewer.value }, null, 8, ["viewer"])
      ]),
      isDeepearth
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(TimeLine, { viewer: cesiumViewer.value }, null, 8, ["viewer"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["cesium-info-button cesium-button", { toolButtonActive: infoOn.value }]),
        title: _ctx.$t('NavigationBar.identify'),
        onClick: toggleInfo
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_InfoFilled)
          ]),
          _: 1
        })
      ], 10, _hoisted_6),
      _createElementVNode("div", {
        class: _normalizeClass(["cesium-button", { toolButtonActive: distanceMeasureOn.value }]),
        title: _ctx.$t('NavigationBar.distance'),
        onClick: toggleDistanceMeasureOn
      }, _hoisted_9, 10, _hoisted_7),
      _createElementVNode("div", {
        class: _normalizeClass(["cesium-button", { toolButtonActive: areaMeasureOn.value }]),
        title: _ctx.$t('NavigationBar.area'),
        onClick: toggleAreaMeasureOn
      }, _hoisted_12, 10, _hoisted_10)
    ]),
    _createElementVNode("div", {
      class: "bottom-tool",
      onClick: switchLatLonFormat,
      style: {"cursor":"default"}
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('NavigationBar.lon')), 1),
            _createTextVNode(" " + _toDisplayString(formattedLon.value), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('NavigationBar.lat')), 1),
            _createTextVNode(" " + _toDisplayString(formattedLat.value), 1)
          ]),
          (viewpoint.value.mode == Cesium.SceneMode.SCENE3D)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('NavigationBar.height')), 1),
                _createTextVNode(" " + _toDisplayString(viewpoint.value.height), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (viewpoint.value.mode != Cesium.SceneMode.SCENE3D && !!distanceLabel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(distanceLabel.value), 1),
            _createElementVNode("div", {
              id: "scale-bar",
              style: _normalizeStyle({ width: barWidth.value + 'px' })
            }, null, 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(FixedIdentifyPopup, {
      enabled: infoOn.value,
      position: clickPosition.value
    }, null, 8, ["enabled", "position"])
  ], 64))
}
}

})